module.exports = __webpack_public_path__ + "img/heroPlain.1c83c19c.png";